/**
 * Maakt van een Firebase-foutcode bij het inloggen een zin die op het scherm kan.
 *
 * Voorheen ging de ruwe fout door `alert(err)` naar buiten. Een gebruiker las
 * dan letterlijk 'E-mailadres is badly formatted' — Engels, in een popup, en
 * zonder te zeggen wat hij eraan moet doen. Gemeld door Duurzame Vecht
 * (2026-09-23), samen met de meldingslus op dit scherm.
 *
 * Elke code levert iets op; de onbekende tak herhaalt de code met opzet, want
 * dat is het enige spoor dat de ondersteuning heeft als iemand meldt 'er
 * gebeurt niets'. Zelfde opzet als `resetPasswordMessage`.
 *
 * @param {string | undefined | null} code - Firebase-foutcode, bijv. 'auth/invalid-email'
 * @returns {string} De melding in het Nederlands, nooit leeg
 */
const loginMessage = (code) => {
    switch (code) {
        case 'auth/invalid-email':
        case 'auth/missing-email':
            return 'Dit is geen geldig emailadres. Controleer of het veld helemaal ingevuld is — soms vult de browser alleen het wachtwoord in.'
        case 'auth/user-not-found':
        case 'auth/wrong-password':
        case 'auth/invalid-credential':
        case 'auth/invalid-login-credentials':
            // Eén tekst voor alle vier: welke van de twee fout is, is een
            // aanwijzing voor iemand die adressen afgaat om te zien welke
            // bestaan.
            return 'Het emailadres of het wachtwoord klopt niet. Weet je je wachtwoord niet meer, klik dan op \'Wachtwoord vergeten?\'.'
        case 'auth/user-disabled':
            return 'Dit account is geblokkeerd. Neem contact op met Deccos via info@deccos.nl.'
        case 'auth/too-many-requests':
            return 'Er zijn te veel pogingen gedaan. Wacht een paar minuten en probeer het opnieuw, of stuur een mailtje naar info@deccos.nl.'
        case 'auth/network-request-failed':
            return 'Er is geen verbinding met Deccos. Controleer je internetverbinding en probeer het opnieuw.'
        default:
            return `Inloggen is niet gelukt (${code || 'onbekende fout'}). Probeer het zo nog eens, of stuur een mailtje naar info@deccos.nl.`
    }
}

export default loginMessage
